import axios, { AxiosInstance } from 'axios';

import { Configuration } from 'src/Services/API/generated';

export enum BudgetBreakdownMetric {
  REALIZED = 'REALIZED',
  REMAINING = 'REMAINING',
  PROJECTED_OVERRUN = 'PROJECTED_OVERRUN',
}

export enum BudgetBreakdownLineOrigin {
  RECURRENCE = 'RECURRENCE',
  MANUAL = 'MANUAL',
  REAL_EXPENSE = 'REAL_EXPENSE',
}

export interface BudgetBreakdownLineDto {
  id: string;
  label: string;
  category: string;
  amount: number;
  date?: string | null;
  origin: BudgetBreakdownLineOrigin;
  isPaid: boolean;
}

export interface BudgetBreakdownTermDto {
  label: string;
  value: number;
  sign: 1 | -1;
}

export interface BudgetBreakdownDto {
  metric: BudgetBreakdownMetric;
  formulaLabel: string;
  formulaTerms: BudgetBreakdownTermDto[];
  total: number;
  lines: BudgetBreakdownLineDto[];
}

export class BudgetBreakdownApi {
  private axiosInstance: AxiosInstance;

  constructor(configuration: Configuration) {
    this.axiosInstance = axios.create({
      baseURL: configuration.basePath ?? '',
      ...configuration.baseOptions,
    });
  }

  async getBreakdown(
    assetId: string,
    year: number,
    metric: BudgetBreakdownMetric
  ): Promise<BudgetBreakdownDto> {
    const response = await this.axiosInstance.get<BudgetBreakdownDto>(
      `/assets/${assetId}/overview/manager/breakdown`,
      { params: { year, metric } }
    );
    return response.data;
  }
}
